import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { RecommendationsFormComponent } from '../community/recommandations-form/recommandations-form.component';
import { environment } from 'src/environments/environment';
import { AppState } from 'src/app/shareModule/states/app.state';
import { select, Store } from '@ngrx/store';
import { BehaviorSubject, filter, Subscription } from 'rxjs';
import { selectUser } from 'src/app/shareModule/states/user-details';
import { User } from 'src/app/shareModule/models/user.model';
import { AddProductComponent } from 'src/app/admin/sub-admin/add-product/add-product.component';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { CommonService } from 'src/app/shareModule/services/common.service';

@Component({
  selector: 'app-recommend-page',
  templateUrl: './recommend-page.component.html',
  styleUrl: './recommend-page.component.scss'
})
export class RecommendPageComponent implements OnInit, OnDestroy {
  private destroy$ = new BehaviorSubject<void>(null);

  @ViewChild("AddShop") addProductComponent: AddProductComponent;

  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private local: LocalServiceService,
    private modalService: NgbModal,
    private store: Store<AppState>,
    private roleService: RoleService,
    private sharedService: SharedService,
    private cdr: ChangeDetectorRef,
    private bottomSheet : MatBottomSheet,
    private commonService: CommonService
  ) {

  }

  public recommendations = []
  public myRecommendations = []
  public catsCount = []

  public isUserAdmin = false;

  private user: any;




  public allProductsCount = 0

  public get areAllSelected() {
    return this.catsCount.filter(cat => cat.recommendationCounts && cat.name?.trim()).every(cat => cat.selected)
  }
  public selectAll() {
    if (this.areAllSelected) {
      this.catsCount.forEach(cat => cat.selected = false);
      this.fetchRecommdations();

      return
    }

    this.catsCount.forEach(cat => cat.selected = true);


    this.fetchRecommdations();

  }

  public selectcat(cat) {
    console.log("selecting", cat)
    cat.selected = !cat.selected;
    // if(cat.selected){
    //   this.selectedCats.push(cat.id)

    // }else{
    //   this.selectedCats.splice(this.selectedCats.indexOf(cat.categorieChildId), 1)
    // }
    this.fetchRecommdations();
  }
  private filterMyRecommendations() {
    this.myRecommendations = Array.from(this.recommendations.filter(recommemdation => recommemdation.memberId == this.user?.id))
  }
  public rebuilder = true;
  private fetchRecommdations() {
    //console.trace('recomm')
    this.rebuilder = false;
    if (this.local.getUser() == null) {
      return;
    }
    this.auth.getallrecommendations({
      categries: this.catsCount.filter(cat => cat.selected).map(cat => cat.id)
    })
      .subscribe({
        next: (data: any) => {
          this.recommendations = data.data;
          console.log('Recomms', this.recommendations)
          this.filterMyRecommendations();
          this.rebuilder = true
          this.cdr.detectChanges()
        },
        error: (err) => {
          console.error(err);
          this.rebuilder = true
          this.toastr.error("Error while fetching recommendations")
          this.cdr.detectChanges()
        }
      })
  }

  public editRecommendation(recomm) {
    if(!this.local.getUser()){
      this.commonService.clickButton('loginBtn')
      return;
    }
    const s = this.modalService.open(RecommendationsFormComponent);
    const originalSubregion = this.subRegionList.find(subRegion => subRegion.name == recomm.regionName)
    s.componentInstance.editRecommId = recomm.id;
    s.componentInstance.name = recomm.nameOfServiceProvider
    s.componentInstance.contactDetails = recomm.phone
    s.componentInstance.company = recomm.company
    s.componentInstance.usp1 = recomm.uniqueSellingPointOne
    s.componentInstance.usp2 = recomm.uniqueSellingPointTwo
    s.componentInstance.isEdit = true
    s.componentInstance.selectedSubRegion = originalSubregion
    console.log( originalSubregion, 'guven', this.subRegionList, recomm.regionName)
    s.componentInstance.banner_image_url = this.imageUrl + recomm.imageLocation;
    s.componentInstance.additionalTags = JSON.stringify(recomm.additionalTags)
    s.componentInstance.pointOfContact = recomm.pointOfContact


    s.hidden.subscribe({
      next: () => {
        this.fetchRecommdations();

      }
    });


  }

  public openAddRecommendationForm() {
    if(!this.local.getUser()){
      this.commonService.clickButton('loginBtn')
      return;
    }
    if(this.sharedService.isBrowser() && window.innerWidth <= 767){
      this.bottomSheet.open(RecommendationsFormComponent, {panelClass: 'bottom-sheet-1'}).afterDismissed().subscribe(()=>this.fetchRecommdations())

    }else{
      const s = this.modalService.open(RecommendationsFormComponent)
      s.hidden.subscribe({
        next: () => {
          this.fetchRecommdations();
        }
      });

    }


   

  }

  public promoteRecommendationToProduct(recomm){
    this.addProductComponent.promoteRecommendation(recomm);
  }

  public imageUrl = environment.ImageUrl

  public tabs = [{ title: 'Latest' }, { title: 'My Recommendations' }, ]

  public onTabChange(tabIndex) {

  }



  private _roleSubscription : Subscription | null = null;
  private _userSubscritpion  : Subscription | null = null;
  private subRegionList =[]

  private getSubRegionList(): void {
    this.auth.getMemberShopSubRegion().subscribe((response) => {
      this.subRegionList = response?.body || [];
    });
  }

  public selectedMemberRegion
  ngOnInit(): void {
    this.getSubRegionList();

    this.local.getUserDetailsObserver().subscribe((user) => {
      if (user?.id) {
        this.user = user;
      }
      this.fetchRecommdations();
    });
    this._roleSubscription = this.roleService.rolesSubject.subscribe(() => {
      this.isUserAdmin = this.roleService?.roles?.userType.includes('ADMIN')
    })

    if(this.sharedService.isBrowser()){
      this._userSubscritpion=  this.store.pipe(select(selectUser)).pipe(filter(user => !!user)).subscribe((r: User) => {
        this._getRecomms(r)
      });
     this._getRecomms(this.local.getUser())
    }
   
   
  }
  private _getRecomms(r){
    if (r?.regionName) {
      this.selectedMemberRegion = r.regionName;
      this.auth.getCountsOfRecommendationCategoriestInSubRegion(Number(r.region)).subscribe({
        next: (data: any) => {
          this.catsCount = data.data.filter(cat => cat.recommendationCounts && cat.name?.trim());
          this.catsCount.forEach(cat => cat.selected = true);
          this.cdr.detectChanges();

        },
        error: (err) => {
          console.error(err);
          this.toastr.error("Something went wrong while fetching counts")
        }
      })
      //this._getMemberShopProduct(); 

    }else{
      console.error("Invalid r given to function")
    }
  }

  ngOnDestroy(): void {
    this._roleSubscription?.unsubscribe();
    this._userSubscritpion?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
